import * as React from "react";
import get from "lodash/get";

import "./RewardsToNextTier.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import { StoreState } from "../../reducers";

export interface RewardsToNextTierProps extends ComponentBaseProps {
  onClick: () => void;
  action: string;
  successScreen: string;
  mode: string;
  content: string;
  rewardStats: StoreState["reward"]["rewardStats"];
}

export class RewardsToNextTier extends ComponentBase<RewardsToNextTierProps> {
  // tslint:disable:cyclomatic-complexity
  render() {
    const {
      style,
      classNames,
      rewardStats,
      action,
      successScreen,
      mode,
      isEditing,
    } = this.props;
    const rewardsToNextTier = get(rewardStats, "tierResult.creditsToNextTier");

    return (
      <div
        onDragStart={this.onDragStart}
        id={this.props.configName}
        onAnimationEnd={this.resetAnimation}
        style={{
          ...style,
          cursor: action || successScreen ? "pointer" : "inherit",
        }}
        className={`RewardsToNextTier-text  RewardsToNextTier-mode-${
          mode || "default"
        } ${classNames || ""} ${
          !isEditing ? "RewardsToNextTier-text-preview" : ""
        } ${this.state.animationClass}`}
        aria-label={get(this.props, "label", "")}
        tabIndex={action ? 0 : undefined}
        ref={(component) => (this.component = component)}
      >
        {rewardsToNextTier}
      </div>
    );
  }
}
